import React from 'react';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import ButtonLink from '../../../elements/ButtonLink';
import styles from '../../authentication/authentication.module.scss';
import EmailLoginButton from '../../authentication/EmailLoginButton';
import LinkedinLogin from '../../authentication/LinkedinLoginButton';

/**
 * Shows the login options to complete the add event action
 *
 * @param {Object} props - The props object containing user and event.
 * @param {Object} props.user - The user object.
 * @param {Object} props.event - The event object.
 * @return {JSX.Element} The rendered JSX element.
 */
function AddWithCodeLoginRequiredFlow(props) {
    const { user, event } = props,
        i18n = useI18n();

    if (!event) return null;
    if (user) return null;

    return (
        <div
            className='unmargin-right'
            style={{
                padding: '40px 0 40px 30px',
            }}>
            <h3 style={{ marginBottom: '10px' }}>
                {i18n['label.statupscreen.registerlabel']}
            </h3>
            <LinkedinLogin
                className={[styles.ActionButton].join(' ')}
                i18n={i18n}>
                {i18n['label.register.by.linkedin']}
            </LinkedinLogin>
            <EmailLoginButton
                className={[styles.ActionButton].join(' ')}
                href='/register'
                next>
                {i18n['label.register.by.email']}
            </EmailLoginButton>
            <div
                style={{
                    padding: '37px 30px 0 0',
                }}>
                <ButtonLink href='/login'>
                    {i18n['label.statupscreen.loginlabel']}
                </ButtonLink>
            </div>
        </div>
    );
}

export default AddWithCodeLoginRequiredFlow;
